import type { AnonymizationMode } from '../types/api';
import {
  MASK_CHAR_OPTIONS,
  MODES,
  MODE_SAMPLE_INPUT,
  getModeExample,
} from '../utils/modes';

interface Props {
  mode: AnonymizationMode;
  maskChar: string;
  onModeChange: (mode: AnonymizationMode) => void;
  onMaskCharChange: (char: string) => void;
  disabled?: boolean;
}

export function ModeSelector({
  mode,
  maskChar,
  onModeChange,
  onMaskCharChange,
  disabled = false,
}: Props) {
  const usesMaskChar = mode === 'mask' || mode === 'redact';

  return (
    <div className="mode-section">
      <div className="mode-header">
        <h3 className="mode-title">Como substituir os dados encontrados</h3>
        <p className="mode-hint">
          A pseudonimização é reversível com a chave da organização (LGPD Art. 13, IV).
          As demais opções apagam o dado original de forma irreversível (Art. 12).
        </p>
      </div>

      <div className="mode-grid">
        {MODES.map((m) => {
          const selected = m.value === mode;
          return (
            <label
              key={m.value}
              className={`mode-card${selected ? ' selected' : ''}${disabled ? ' disabled' : ''}`}
            >
              <input
                type="radio"
                name="anonymization-mode"
                value={m.value}
                checked={selected}
                disabled={disabled}
                onChange={() => onModeChange(m.value)}
                className="mode-radio"
              />
              <span className="mode-card-head">
                <span className="mode-card-label">{m.label}</span>
                <span className={`mode-tag${m.reversible ? ' reversible' : ''}`}>
                  {m.reversible ? 'Reversível' : 'Irreversível'}
                </span>
              </span>
              <span className="mode-card-desc">{m.description}</span>
              <span className="mode-example">
                <span className="mode-example-from">{MODE_SAMPLE_INPUT}</span>
                <span className="mode-example-arrow">→</span>
                <span className="mode-example-to">
                  {getModeExample(m.value, maskChar)}
                </span>
              </span>
            </label>
          );
        })}
      </div>

      {usesMaskChar && (
        <div className="mask-char-row">
          <span className="mask-char-label">Símbolo:</span>
          {MASK_CHAR_OPTIONS.map((c) => (
            <button
              key={c}
              type="button"
              className={`mask-char-btn${c === maskChar ? ' selected' : ''}`}
              disabled={disabled}
              onClick={() => onMaskCharChange(c)}
              aria-label={`Usar ${c} como símbolo`}
            >
              {c}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
